import React, { useState, useEffect, useMemo } from 'react';
import { CnAsyncSelect } from '@sto/cn-ui';
import { request } from '@/api/request';
import { ENV } from '@/configs/baseUrl';
import styles from './index.module.scss';

/**
 * 自定义远程选择组件
 * @param value 值
 * @param onChange 变化事件
 * @param remoteConfig 远程配置 { 
  * url, 
  * method = 'GET', 
  * params = {}, 
  * domainConfig: {
  *   daily: 'https://xxx',
  *   dev: 'https://xxx',
  *   pre: 'https://xxx',
  *   prod: 'https://xxx'
  * } 
 * }
 * @param props 其他属性
 * @returns 
 */
const CustomRemoteSelect = ({ value, onChange, remoteConfig = null, ...props }) => {
  const { url, method = 'GET', params = {}, domainConfig } = remoteConfig || {};

  const requestConfig = useMemo(() => {
    let newUrl = url;
    if (domainConfig) {
      // 有域名配置，使用域名配置
      newUrl = `${domainConfig[ENV]}${url}`;
    }
    const config: any = {
      url: newUrl,
      method,
      params: { ...params },
    };
    if (method === 'POST') {
      config.data = { ...params };
      delete config.params;
    }
    return {
      service: () => {
        return request(config);
      },
    };
  }, [url, method, params]);

  return (
    <div className={styles.customRemoteSelect}>
      <CnAsyncSelect
        {...props}
        value={value}
        onChange={onChange}
        requestConfig={requestConfig}
      />
    </div>
  );
};

export default CustomRemoteSelect;